import { render } from "./LinksRegistro.vue?vue&type=template&id=f1027910"
import script from "./LinksRegistro.vue?vue&type=script&lang=js"
export * from "./LinksRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__